
import StoryElement from "./StoryElement"
import StoryModelEvent from "./StoryModelEvent"
import StoryNode from "./StoryNode"

export default class StoryArc extends StoryElement {
    /**
    * Initialize a new StoryArc
    * @constructor
    * @param {Story} story
    * @param {} id
    * @param {*} data
    * @param {type} unlockCondition
    * @param {type} availableCondition
    * @param {type} isEnd
    * @returns {StoryArc}
    */
    constructor(story, id, data, unlockCondition, availableCondition, isEnd) {
        id = typeof id !== 'undefined' ? id : StoryElement.generateID();
        super(id, data, unlockCondition, availableCondition, isEnd);

        this.story = story;
        this.storyNodes = [];
    }
    /**
     * Returns an Array with all the StoryNodes in the StoryArc
     * @returns {ArrayIterator}
     */
    getStoryNodes() {
        return this.storyNodes.getIterator();
    }
    /**
     * Insert a new StoryNode into the StoryArc
     * @param {*} data
     * @param {LogicalExpresion} unlockCondition
     * @param {LogicalExpresion} availableCondition
     * @param {number} id
     * @returns {StoryNode}
     */
    insertStoryNode(data, unlockCondition, availableCondition, id) {
        //TODO: implement
        id = typeof id !== 'undefined' ? id : StoryElement.generateID();

        var storyNode = new StoryNode(this, id, data, unlockCondition, availableCondition);
        this.storyNodes.push(storyNode);
        this.dispatchEvent(StoryModelEvent.STORY_NODE_ADDED, { storyArc: this, storyNode: storyNode });
        return storyNode;
    }
    /**
     * Remove a StoryNode from the StoryArc
     * @param {StoryNode} storyNode
     * @returns {undefined}
     */
    removeStoryNode(storyNode) {
        if (this.storyNodes.remove(storyNode)) {
            this.dispatchEvent(StoryModelEvent.STORY_NODE_REMOVED, { storyArc: this, storyNode: storyNode });
        } else {
            throw new Error("Storynode is not in this StoryArc");
        }
    }
    /**
     * Get a StoryNode by its id.
     * @param {number} id
     * @returns {StoryNode} The StoryNode or null if it cannot be found
     */
    getStoryNodeById(id) {
        var storyNodeItr = this.getStoryNodes();

        while (storyNodeItr.hasNext()) {
            var storyNode = storyNodeItr.next();
            if (storyNode.id === id) {
                return storyNode;
            }
        }
        return null;
    }
    /**
     * Dispatches an update event
     * @returns {undefined}
     */
    update() {
        this.dispatchEvent(StoryModelEvent.STORY_ARC_UPDATED, this);
    }
}


